/**
 * H5 垂直抽屉顶部扣减：与 `--safe-area-inset-top` / initDistance 二选一。
 * safeTop > 0 时使用安全区；否则使用 initDistance（浏览器 H5 无原生注入时的兜底）。
 */
export function resolveDrawerVerticalTopOffsetPx(options: {
  isPc: boolean;
  isVertical: boolean;
  safeTop: number;
  initDistance: number;
}): number {
  const { isPc, isVertical, safeTop, initDistance } = options;
  if (!isVertical || isPc) {
    return initDistance;
  }
  return safeTop > 0 ? safeTop : initDistance;
}
